(function($) {

  'use strict';

  function Quantity() {

    var self = this,
        $el = null,
        $input = null,
        $buttons = null,
        min = 0,
        max = 0,
        options = {
          'example': null
        };



    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $el = options.$el;
      $input = $el.find('input[type="number"]');
      min = $input.attr('min');
      max = $input.attr('max');

      // Default max value
      max = (max !== '' && max !== '0') ? max : 1000000;

      $('<div class="quantity-nav"><button class="quantity-button js-quantity-button is-up"></button><button class="quantity-button js-quantity-button is-down"></button></div>')
        .insertAfter($input);

      // Buttons caching after buttons have been added to dom
      $buttons = $el.find('.js-quantity-button');


      $buttons.on('click', function(e) {
        e.preventDefault();
        var oldVal = parseFloat($input.val()),
            newVal = 0;

        if ($(this).hasClass('is-up')) {
          newVal = (oldVal >= max) ? oldVal : oldVal + 1;
        } else {
          newVal = (oldVal <= min) ? oldVal : oldVal - 1;
        }

        $input.val(newVal);
        $input.trigger('change');
      });


      //*************
      // window.cache.$window.on('resize', Utils.debounce(onResize, 400));
      // onResize();     // initial call on load
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Quantity = Quantity;

}(jQuery));